// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` {
  /* Position and sizing of burger button */
  /* Color/shape of burger icon bars */
  /* Position and sizing of clickable cross button */
  /* Color/shape of close button cross */
  /* General sidebar styles */
  /* Wrapper for item list */
  /* Individual item */
  /* Styling of overlay */
}
.bm-burger-button {
  position: fixed;
  width: 36px;
  height: 30px;
  right: 36px;
  top: 36px;
}
.bm-burger-bars {
  background: #DAD2D5;
}
.bm-cross-button {
  height: 2.25em;
  width: 2.25em;
}
.bm-cross {
  background: #DAD2D5;
}
.bm-menu {
  background: #22181C;
  padding: 1.25em;
}
.bm-item-list {
  color: #b8b7ad;
}
.bm-item {
  display: inline-block;
  /* Our sidebar item styling */
  text-decoration: none;
  margin-bottom: 10px;
}
.bm-item:hover {
  border-bottom: none;
}
.bm-overlay {
  background: rgba(0, 0, 0, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/nav/BurgerMenu.scss","webpack://./src/css/config.scss"],"names":[],"mappings":"AAIA;EACC,yCAAA;EASA,oCAAA;EAKA,kDAAA;EAMA,sCAAA;EAKA,2BAAA;EAOA,0BAAA;EAKA,oBAAA;EAaA,uBAAA;AA9CD;AAHC;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAKF;AADC;EACC,mBCfK;ADkBP;AACC;EACC,cCRiB;EDSjB,aCTiB;ADUnB;AAGC;EACC,mBC1BK;ADyBP;AAKC;EACC,mBC7BW;ED8BX,eCrBe;ADkBjB;AAQC;EACC,cAAA;AANF;AAUC;EACC,qBAAA;EAEA,6BAAA;EACA,qBAAA;EACA,mBAAA;AATF;AAYC;EACC,mBAAA;AAVF;AAcC;EACC,8BAAA;AAZF","sourcesContent":["@import \"css/config.scss\";\n\n// react-burger-menu uses all of these classes internally, so we have to wrap\n// them in :global so the names don't get mangled by CSS modules.\n:global {\n\t/* Position and sizing of burger button */\n\t.bm-burger-button {\n\t\tposition: fixed;\n\t\twidth: 36px;\n\t\theight: 30px;\n\t\tright: 36px; // right or left, depending on which side the menu opens from\n\t\ttop: 36px;\n\t}\n\n\t/* Color/shape of burger icon bars */\n\t.bm-burger-bars {\n\t\tbackground: $text;\n\t}\n\n\t/* Position and sizing of clickable cross button */\n\t.bm-cross-button {\n\t\theight: $body-line-height;\n\t\twidth: $body-line-height;\n\t}\n\n\t/* Color/shape of close button cross */\n\t.bm-cross {\n\t\tbackground: $text;\n\t}\n\n\t/* General sidebar styles */\n\t.bm-menu {\n\t\tbackground: $background;\n\t\tpadding: $body-font-size;\n\t\t// padding: 2.5em 1.5em 0;\n\t}\n\n\t/* Wrapper for item list */\n\t.bm-item-list {\n\t\tcolor: #b8b7ad;\n\t}\n\n\t/* Individual item */\n\t.bm-item {\n\t\tdisplay: inline-block;\n\n\t\t/* Our sidebar item styling */\n\t\ttext-decoration: none;\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.bm-item:hover {\n\t\tborder-bottom: none;\n\t}\n\n\t/* Styling of overlay */\n\t.bm-overlay {\n\t\tbackground: rgba(0, 0, 0, 0.3);\n\t}\n}\n","// Brand colors\n$text: #DAD2D5;\n$text-faded: #94878C;\n$background: #22181C;\n$accent-color: #FF3685;\n$blueb: #6093F3;\n$lello: #FFD254;\n$greeb: #7ACE5C;\n\n// Bulma overrides\n$family-sans-serif: Poppins, sans-serif;\n\n$body-font-size: 1.25em;\n$body-line-height: $body-font-size * 1.8;\n\n$primary: $accent-color;\n$body-background-color: $background;\n$strong-color: $accent-color;\n$link: $blueb;\n$link-hover: scale-color($blueb, $saturation: -30%);\n\n// Forces the max width on these display types\n$desktop: 960px;\n$widescreen: 960px;\n$fullhd: 960px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
